var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "presentation",
    focusable: "false",
    viewBox: "2 2 16 16",
    className: "ao ap aq ar as",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ui-icon__outline at"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 13C11.6569 13 13 11.6569 13 10V5.00002C13 3.34316 11.6569 2.00002 10 2.00002C8.34315 2.00002 7 3.34316 7 5.00001V10C7 11.6569 8.34315 13 10 13ZM10 12C8.89543 12 8 11.1046 8 10V5.00001C8 3.89545 8.89543 3.00001 10 3.00002C11.1046 3.00002 12 3.89545 12 5.00002V10C12 11.1046 11.1046 12 10 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9.5C5.27614 9.5 5.5 9.72386 5.5 10C5.5 12.4853 7.51472 14.5 10 14.5C12.4853 14.5 14.5 12.4853 14.5 10C14.5 9.72386 14.7239 9.5 15 9.5C15.2761 9.5 15.5 9.72386 15.5 10C15.5 12.869 13.3033 15.225 10.5 15.4776V17.5C10.5 17.7761 10.2761 18 10 18C9.72386 18 9.5 17.7761 9.5 17.5V15.4776C6.69675 15.225 4.5 12.869 4.5 10C4.5 9.72386 4.72386 9.5 5 9.5Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "ui-icon__filled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10C5.5 9.72386 5.27614 9.5 5 9.5C4.72386 9.5 4.5 9.72386 4.5 10C4.5 12.869 6.69675 15.225 9.5 15.4776V17.5C9.5 17.7761 9.72386 18 10 18C10.2761 18 10.5 17.7761 10.5 17.5V15.4776C13.3033 15.225 15.5 12.869 15.5 10C15.5 9.72386 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.72386 14.5 10C14.5 12.4853 12.4853 14.5 10 14.5C7.51472 14.5 5.5 12.4853 5.5 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 10.0008C12.9996 11.6573 11.6566 13 10 13C8.34315 13 7 11.6569 7 10V5.00002C7 3.34316 8.34315 2.00002 10 2.00002C11.6569 2.00002 13 3.34316 13 5.00002V10.0008Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOn);
export default __webpack_public_path__ + "static/media/mic-on.5c7e90d03e8e1c3a0fcb83159b3efec8.svg";
export { ForwardRef as ReactComponent };